var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9868 20.0007C39.9868 30.1019 32.5014 38.4529 22.7772 39.808C21.8679 39.9341 20.9377 40 19.9934 40C18.9034 40 17.8331 39.9131 16.7908 39.745C7.2711 38.2118 0 29.9548 0 20.0007C0 8.95491 8.95227 0 19.9948 0C31.0374 0 39.9896 8.95491 39.9896 20.0007H39.9868Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0432 14.1826V17.4253H25.999L25.3726 21.7933H22.0432V31.8571C21.3757 31.951 20.6927 32 19.9995 32C19.1993 32 18.4135 31.9353 17.6482 31.8102V21.7933H14V17.4253H17.6482V13.4577C17.6482 10.9963 19.6158 9 22.0442 9V9.00209C22.0514 9.00209 22.0576 9 22.0648 9H26V12.7777H23.4286C22.6644 12.7777 22.0442 13.4066 22.0442 14.1816L22.0432 14.1826Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.5929cea78c1c670a1a4f42d6021a1ccb.svg";
export { ForwardRef as ReactComponent };